var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnglesLeftSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "406.298px",
    height: "375.146px",
    viewBox: "281.275 62.427 406.298 375.146",
    enableBackground: "new 281.275 62.427 406.298 375.146",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M290.43,227.93c-12.207,12.207-12.207,32.031,0,44.238l156.25,156.25c12.207,12.207,32.031,12.207,44.238,0 s12.207-32.031,0-44.238L356.738,250L490.82,115.82c12.207-12.207,12.207-32.031,0-44.238s-32.031-12.207-44.238,0l-156.25,156.25 L290.43,227.93z M634.18,71.68L477.93,227.93c-12.207,12.207-12.207,32.031,0,44.238l156.25,156.25 c12.207,12.207,32.031,12.207,44.238,0s12.207-32.031,0-44.238L544.238,250L678.32,115.82c12.207-12.207,12.207-32.031,0-44.238 s-32.031-12.207-44.238,0L634.18,71.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnglesLeftSolid);
export default __webpack_public_path__ + "static/media/angles-left-solid.e3210ee2edf98108c9b5348ce10ca541.svg";
export { ForwardRef as ReactComponent };